module.exports = __webpack_public_path__ + "img/app_energy.c86e7052.svg";